import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button } from "@digital-services/ui";

import KeyIcon from "@icons/key_16.svg?react";

import { createApiUserRoute } from "../../common";

export const CreateApiUserButton = () => {
  const navigate = useNavigate();

  const { t: tApiUserTab } = useTranslation(undefined, {
    keyPrefix: "api-users"
  });

  return (
    <Button
      size="big"
      variant="primary"
      data-testid="create-api-user-button"
      icon={<KeyIcon />}
      onClick={() => {
        navigate(createApiUserRoute);
      }}
    >
      {tApiUserTab("buttons.create")}
    </Button>
  );
};
